import { mogamboRequestV2 } from '@src/api/utils';
import { BASE_URL } from '@src/const';

export const getAllBusinessList = () => {
  const url = `${BASE_URL}partner/`;
  const response = mogamboRequestV2(url, 'GET');
  return Promise.resolve(response);
};

export const getBusinessData = viaName => {
  const url = `${BASE_URL}business/?via_name=${viaName}&full=True`;
  const response = mogamboRequestV2(url, 'GET');
  return Promise.resolve(response);
};

export const saveBusinessData = data => {
  const url = `${BASE_URL}business/`;
  const response = mogamboRequestV2(url, 'POST', data);
  return Promise.resolve(response);
};

export const transferBusiness = (businessId, additionalHeaders) => {
  const url = '/admin_tools/run_data_transfer_uni_dir/';
  const response = mogamboRequestV2(
    url,
    'POST',
    {
      row_ids: [businessId],
      row_type: 'business',
    },
    undefined,
    additionalHeaders
  );
  return Promise.resolve(response);
};

export const transferTasks = (taskIdList, additionalHeaders) => {
  const url = '/admin_tools/run_data_transfer_uni_dir/';
  const response = mogamboRequestV2(
    url,
    'POST',
    {
      row_ids: taskIdList,
      row_type: 'task',
    },
    undefined,
    additionalHeaders
  );

  return Promise.resolve(response);
};

export const transferSQL = (key, idList, additionalHeaders) => {
  const url = '/admin_tools/run_data_transfer_uni_dir/';
  const response = mogamboRequestV2(
    url,
    'POST',
    {
      row_ids: idList,
      row_type: key,
    },
    undefined,
    additionalHeaders
  );

  return response;
};

export const getBusinessPartnerList = () => {
  const url = `${BASE_URL}partner/`;
  const response = mogamboRequestV2(url, 'GET');
  return Promise.resolve(response);
};

export const getBusinessTriggerSettings = businessId => {
  const url = `${BASE_URL}bot_prompt_trigger/${businessId}/`;
  const response = mogamboRequestV2(url, 'GET');
  return Promise.resolve(response);
};

export const savePromptTriggerData = (businessId, data) => {
  const url = `${BASE_URL}bot_prompt_trigger/${businessId}/`;
  const response = mogamboRequestV2(url, 'POST', data, true);
  return Promise.resolve(response);
};

export const getBusinessDefaultTeam = businessId => {
  const url = `${BASE_URL}business/teams/${businessId}/`;
  const response = mogamboRequestV2(url, 'GET');
  return Promise.resolve(response);
};

export const saveBusinessDefaultTeam = (businessId, data) => {
  const url = `${BASE_URL}business/teams/${businessId}/`;
  const response = mogamboRequestV2(url, 'POST', data);
  return Promise.resolve(response);
};

export const getAllPlatforms = () => {
  const url = `${BASE_URL}business/platforms/`;
  const response = mogamboRequestV2(url, 'GET');
  return Promise.resolve(response);
};

export const getPlatformDeployments = businessId => {
  const url = `${BASE_URL}business/platforms/deployments/${businessId}/`;
  const response = mogamboRequestV2(url, 'GET');
  return Promise.resolve(response);
};

export const savePlatformDeployments = (businessId, deployments) => {
  const url = `${BASE_URL}business/platforms/deployments/${businessId}/`;
  const response = mogamboRequestV2(url, 'POST', deployments, true);
  return Promise.resolve(response);
};
